import React, { Fragment } from "react";

import img13 from "../../../images/service/Cryptocurrency Marketing/1.png";
import img14 from "../../../images/service/Cryptocurrency Marketing/2.png";
import img15 from "../../../images/service/Cryptocurrency Marketing/3.png";


// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Crypto Branding & Positioning",
    content:
      "Create a strong brand identity for your crypto project that builds trust and market credibility.",
  },
  {
    icon: sIcon2,
    title: "Community Building & Management",
    content:
      "Grow and manage active communities across Telegram, Discord, Twitter, and Web3 platforms.",
  },
  {
    icon: sIcon3,
    title: "Token & Exchange Marketing",
    content:
      "Increase token visibility and trading activity through targeted exchange and launch campaigns.",
  },
];

const benefits = [
  {
    title: "Increased Project Visibility",
    description:
      "Reach the right crypto audience across Web3 channels and platforms.",
    icon: sIcon1,
  },
  {
    title: "Stronger Community Trust",
    description:
      "Engaged communities drive adoption and long-term project growth.",
    icon: sIcon2,
  },
  {
    title: "Higher Token Adoption",
    description:
      "Strategic marketing boosts token usage and ecosystem participation.",
    icon: sIcon3,
  },
  {
    title: "Sustainable Growth",
    description:
      "Organic and paid campaigns ensure steady project momentum.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is cryptocurrency marketing?",
    a: "Cryptocurrency marketing focuses on promoting blockchain projects, tokens, and Web3 platforms to targeted crypto audiences.",
  },
  {
    q: "Which channels are best for crypto marketing?",
    a: "Social media, influencer marketing, community platforms, PR, and exchange promotions are most effective.",
  },
  {
    q: "Do you support token launches?",
    a: "Yes. We provide end-to-end marketing support for token launches and exchange listings.",
  },
  {
    q: "Is crypto marketing compliant?",
    a: "We follow platform policies and regional guidelines to ensure responsible marketing practices.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function CryptocurrencyMarketingServices() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Cryptocurrency Marketing Services"
        pagesub="Targeted Web3 marketing strategies for blockchain growth"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Accelerate Growth with{" "}
            <span className="gradient-text">Crypto Marketing</span>
          </>
        }
        subtitle={`Boost visibility, community engagement, and adoption of your
blockchain project with result-driven cryptocurrency marketing strategies.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Cryptocurrency Marketing Services"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is Cryptocurrency Marketing?"
        image={img14}
        paragraphs={[
          "Cryptocurrency marketing is the process of promoting blockchain projects, tokens, and decentralized platforms to crypto-native and mainstream audiences.",
          "It focuses on building awareness, trust, and long-term engagement through Web3-specific channels and communities.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Cryptocurrency Marketing Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Crypto Projects Need Specialized Marketing"
        image={img15}
        paragraphs={[
          "Traditional marketing approaches often fail in the crypto space due to strict platform rules and niche audiences.",
          "Crypto marketing requires deep industry knowledge, community trust, and compliance with evolving regulations.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Cryptocurrency Marketing"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Crypto Marketing Strategy"
        subtitle="Built for visibility, trust, and adoption"
        features={[
          {
            icon: sIcon1,
            title: "Community-First Approach",
            description:
              "Engage and grow loyal crypto communities.",
          },
          {
            icon: sIcon2,
            title: "Influencer Collaborations",
            description:
              "Partner with trusted crypto influencers and KOLs.",
          },
          {
            icon: sIcon3,
            title: "PR & Media Outreach",
            description:
              "Gain exposure on top blockchain and crypto publications.",
          },
          {
            icon: sIcon4,
            title: "Launch Campaigns",
            description:
              "Strategic support for token launches and exchange listings.",
          },
          {
            icon: sIcon5,
            title: "Performance Tracking",
            description:
              "Data-driven optimization and transparent reporting.",
          },
          {
            icon: sIcon6,
            title: "Compliance-Aware Marketing",
            description:
              "Responsible campaigns aligned with industry standards.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Experienced Web3 marketing specialists",
          "Community-driven growth strategies",
          "End-to-end crypto marketing support",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
